import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../../redux/api";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { ModalBody } from "reactstrap";
import { updateProfile } from "../../../../redux/profile/action";
import { getIndustry, getSkillswithCategory } from "../../../../redux/categary/action";
import { titlevalidation } from "../../../Common/commonvalidation";

const ProfileModelCategoerySubcategory = ({
  formData,
  setFormData,
  edittype,
  setCatsubcat,
}) => {
  const dispatch = useDispatch();

  const industrylist = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  const [selectedIndustries, setSelectedIndustries] = useState(
    formData?.industries || []
  );
  const [selectedCategories, setSelectedCategories] = useState(
    formData?.categories || []
  );
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState({});
  const [validation, setValidation] = useState(false);

  // Fetch industries initially
  useEffect(() => {
    dispatch(getIndustry());
  }, [dispatch]);

  // Restore all options when formData has selections
  useEffect(() => {
    if (formData?.industries?.length > 0) {
      fetchCategories(formData.industries.map((i) => i.id)).then(() => {
        if (formData?.categories?.length > 0) {
          formData.categories.forEach((cat) => {
            fetchSubcategories(cat.id);
          });
        }
      });
    }
  }, [formData]);

  // Fetch categories by industry ids
  const fetchCategories = async (industryIds) => {
    try {
      const allCategories = [];
      for (const id of industryIds) {
        const res = await axiosInstance.get(`category?type=2&parent_id=${id}`);
        const options = res.data.response.map((cat) => ({
          value: cat.id,
          label: cat.title,
        }));
        allCategories.push(...options);
      }
      setCategoryOptions(allCategories);
    } catch (err) {
      console.error("Error fetching categories:", err);
      setCategoryOptions([]);
    }
  };

  // Fetch subcategories by category id
  const fetchSubcategories = async (parentId) => {
    try {
      const res = await axiosInstance.get(
        `category?type=3&parent_id=${parentId}`
      );
      const options = res.data.response.map((sub) => ({
        value: sub.id,
        label: sub.title,
      }));
      setSubcategoryOptions((prev) => ({ ...prev, [parentId]: options }));
    } catch (err) {
      console.error("Error fetching subcategories:", err);
    }
  };

  // Industry change
  const handleIndustryChange = async (options) => {
    const industries =
      options?.map((opt) => ({
        id: opt.value,
        title: opt.label,
      })) || [];
    setSelectedIndustries(industries);
    formik.setFieldValue("industries", industries);

    // reset categories & subcategories
    setSelectedCategories([]);
    setSubcategoryOptions({});
    setCategoryOptions([]);

    if (industries.length > 0) {
      await fetchCategories(industries.map((i) => i.id));
    }
  };

  // Category change
  const handleCategoryChange = (options) => {
    const categories =
      options?.map((opt) => {
        fetchSubcategories(opt.value);
        return {
          id: opt.value,
          title: opt.label,
          sub_categories: [],
        };
      }) || [];
    setSelectedCategories(categories);
    formik.setFieldValue("categories", categories);
  };

  // Subcategory change
  const handleSubcategoryChange = (selectedOptions, index) => {
    const updated = [...selectedCategories];
    updated[index].sub_categories = selectedOptions.map((s) => ({
      id: s.value,
      title: s.label,
    }));
    setSelectedCategories(updated);
    formik.setFieldValue("categories", updated);
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      industries: selectedIndustries,
      categories: selectedCategories,
    },
    validationSchema: Yup.object().shape({
      industries: Yup.array().min(1, "Industry is required"),
      categories: Yup.array().min(1, "Category is required"),
    }),
    onSubmit: () => {
      const noIndustry = selectedIndustries.length === 0;
      const noCategory = selectedCategories.length === 0;

      if (noIndustry || noCategory) {
        setValidation(true);
        return;
      }

      const payload = {
        type: "industry_category_skills",
        industries: selectedIndustries.map((i) => ({ id: i.id })),
        categories: selectedCategories.map((c) => ({
          id: c.id,
          sub_categories: c.sub_categories.map((s) => ({ id: s.id })),
        })),
      };
      console.log(payload, "payload");

      if (edittype === 1) {
        dispatch(updateProfile(payload));
        setCatsubcat(false);
      } else {
        setFormData({
          ...formData,
          industries: selectedIndustries,
          categories: selectedCategories,
          skills: [],
        });
        dispatch(
          getSkillswithCategory(selectedCategories.map((c) => c.id).toString())
        );
        setCatsubcat(false);
      }
    },
  });

  return (
    <>
      <button onClick={() => setCatsubcat(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      <ModalBody>
        <h4>Edit Industry, Category & Subcategory</h4>
        <form onSubmit={formik.handleSubmit}>
          {/* Industry */}
          <div className="form-group">
            <label>Select Industries</label>
            <ReactSelect
              options={
                Array.isArray(industrylist)
                  ? industrylist.map((i) => ({ value: i.id, label: i.title }))
                  : []
              }
              isMulti
              placeholder="Select Industries"
              value={selectedIndustries.map((i) => ({
                value: i.id,
                label: i.title,
              }))}
              onChange={handleIndustryChange}
            />
          </div>

          {/* Category */}
          {selectedIndustries.length > 0 && (
            <div className="form-group">
              <label>Select Categories</label>
              <ReactSelect
                options={categoryOptions}
                isMulti
                placeholder="Select Categories"
                value={selectedCategories.map((c) => ({
                  value: c.id,
                  label: c.title,
                }))}
                onChange={handleCategoryChange}
              />
            </div>
          )}

          {/* Subcategory (optional) */}
          {selectedCategories.length > 0 &&
            selectedCategories.map((cat, idx) => (
              <div key={cat.id} className="row modal-edit-row mb-2 align-items-center">
                <div className="col-md-4">
                  <label className="mb-0">{cat.title}</label>
                </div>
                <div className="col-md-8">
                  <ReactSelect
                    options={subcategoryOptions[cat.id] || []}
                    isMulti
                    value={cat.sub_categories.map((s) => ({
                      value: s.id,
                      label: s.title,
                    }))}
                    placeholder="Select Subcategories"
                    onChange={(opts) => handleSubcategoryChange(opts, idx)}
                  />
                </div>
              </div>
            ))}
        </form>
      </ModalBody>

      {validation && (
        <p style={{ color: "red" }}>
          Please select at least 1 industry and 1 category
        </p>
      )}

      <div className="modal-footer mt-3">
        <button
          className="btn"
          onClick={() => {
            setValidation(true);
            formik.handleSubmit();
          }}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default ProfileModelCategoerySubcategory;
